var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9937 0H4.33711C1.94557 0 0 1.94717 0 4.34067V12.2667C0 14.6602 1.94557 16.6073 4.33711 16.6073H12.9937C15.3852 16.6073 17.3308 14.6602 17.3308 12.2667V4.34067C17.3308 1.94717 15.3852 0 12.9937 0ZM1.53 4.34067C1.53 2.79176 2.78947 1.53125 4.33711 1.53125H12.9937C14.5413 1.53125 15.8008 2.79176 15.8008 4.34067V12.2667C15.8008 13.8156 14.5413 15.0761 12.9937 15.0761H4.33711C2.78947 15.0761 1.53 13.8156 1.53 12.2667V4.34067Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66548 12.3403C10.8894 12.3403 12.6997 10.5295 12.6997 8.30275C12.6997 6.07601 10.8904 4.2652 8.66548 4.2652C6.44056 4.2652 4.63123 6.07601 4.63123 8.30275C4.63123 10.5295 6.44056 12.3403 8.66548 12.3403ZM8.66548 5.79743C10.0465 5.79743 11.1697 6.92159 11.1697 8.30373C11.1697 9.68588 10.0465 10.81 8.66548 10.81C7.28446 10.81 6.16122 9.68588 6.16122 8.30373C6.16122 6.92159 7.28446 5.79743 8.66548 5.79743Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0732 4.91755C13.6721 4.91755 14.1602 4.43002 14.1602 3.82969C14.1602 3.22935 13.6731 2.74182 13.0732 2.74182C12.4734 2.74182 11.9863 3.22935 11.9863 3.82969C11.9863 4.43002 12.4734 4.91755 13.0732 4.91755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramaIcon);
export default __webpack_public_path__ + "static/media/instagrama-icon.302dc64c6279cba3749553b165099829.svg";
export { ForwardRef as ReactComponent };